import {Directive, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {OtpSplitInputService} from './otp-split-input.service';
import {Platform} from '@angular/cdk/platform';

@Directive({
  selector: '[otpSplitInput]'
})
export class OtpSplitInputDirective implements OnInit, OnDestroy {

  constructor(
    private elementRef: ElementRef<HTMLInputElement>,
    private otpSplitInputService: OtpSplitInputService,
    private platform: Platform
  ) {
    let element = elementRef.nativeElement;
    element.type = 'text';
    element.inputMode = 'numeric';
    element.autocomplete = 'one-time-code';

    if (!platform.WEBKIT || !platform.IOS) {
      element.maxLength = otpSplitInputService.inputMaxLength;
    }
  }

  public ngOnInit(): void {
    this.otpSplitInputService.addInput(this.elementRef);
  }

  public ngOnDestroy(): void {
    this.otpSplitInputService.removeInput(this.elementRef);
  }

  @HostListener('change', ['$event'])
  public onChange(e: Event): void {
    this.otpSplitInputService.onChange(e, this.elementRef);
  }

  @HostListener('keydown.backspace', ['$event'])
  public onBackspace(e: KeyboardEvent): void {
    this.otpSplitInputService.onBackSpace(e, this.elementRef);
  }

  @HostListener('input', ['$event'])
  public onInput(e: InputEvent): void {
    this.otpSplitInputService.onInput(e, this.elementRef);
  }

  @HostListener('paste', ['$event'])
  public onPaste(e: ClipboardEvent): void {
    this.otpSplitInputService.onPaste(e, this.elementRef);
  }

  @HostListener('focus', ['$event'])
  public onFocus(e: FocusEvent): void {
    this.otpSplitInputService.onFocus(e, this.elementRef);
  }
}
